export default __webpack_public_path__ + "8f1e0300e8d26fa8919d1d97e04d6e92.woff2";